export default "__VITE_ASSET__69091d1e__"